<mat-expansion-panel
    class="w-full"
    [expanded]="true">
    <mat-expansion-panel-header class="!font-semibold !text-base pb-2 !pl-2"
        >{{ 'form' | transloco: { COUNT: sortedForms.length } }}
    </mat-expansion-panel-header>

    @for (form of sortedForms; track form.id) {
        <div
            class="pl-0 mb-2 cursor-pointer"
            [class.option-selected]="filterEntitiesTableService.filterByParams()?.forms?.includes(form.id)"
            (click)="filterEntitiesTableService.toggleSelection(form.id, 'forms')">
            <app-checkbox
                [checkboxState]="
                    filterEntitiesTableService.filterByParams()?.forms?.includes(form.id)
                        ? CheckboxState.CHECKED
                        : CheckboxState.UNCHECKED
                " />
            <span class="pl-1 flex-1 overflow-x-hidden text-ellipsis whitespace-nowrap">
                {{ form.name }}
            </span>
        </div>
    } @empty {
        <div class="flex flex-col items-center justify-center h-full text-custom-light-grey">
            <fa-icon
                class="pb-2"
                size="xl"
                [icon]="['fad', 'empty-set']" />

            <span class="!font-normal !text-sm">{{ 'noForm' | transloco }}</span>
        </div>
    }
    @if (filterEntitiesTableService.formsWithPagination()?.hasNextPage) {
        <span
            class="text-custom-dark-grey cursor-pointer hover:underline"
            (click)="
                filterEntitiesTableService.loadFormsWithPagination(
                    filterEntitiesTableService.formsWithPagination()!.page + 1
                )
            ">
            {{ 'displayMore' | transloco }}
            {{
                `(${
                    filterEntitiesTableService.formsWithPagination()!.totalItems -
                    filterEntitiesTableService.formsWithPagination()!.items.length
                })`
            }}
            <fa-icon [icon]="['fas', 'chevron-down']" />
        </span>
    } @else if (filterEntitiesTableService.formsWithPagination()?.hasPreviousPage) {
        <span
            class="text-custom-dark-grey cursor-pointer hover:underline"
            (click)="filterEntitiesTableService.loadFormsWithPagination(0)">
            {{ 'displayLess' | transloco }}

            <fa-icon
                [icon]="['fas', 'chevron-down']"
                [rotate]="180" />
        </span>
    }
</mat-expansion-panel>
